import { createReducer } from "@reduxjs/toolkit";
import { setSocket, stopSocket, startSocket, socketConnected } from "./actions";

const initialState = {
  socket: null,
  isSocketConnected: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(startSocket, (state) => ({
      ...state,
      isSocketConnected: false,
    }))
    .addCase(stopSocket, (state, { payload }) => ({
      ...state,
      isSocketConnected: payload,
    }))
    .addCase(socketConnected, (state) => ({
      ...state,
      isSocketConnected: true,
    }))
    .addCase(setSocket, (state, { payload }) => ({
      ...state,
      socket: payload,
    }));
});
